module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAABM0lEQVQoU2WPO0vDYBSG3zdfrK0XXPQXKAhCKyarjoKzOAj+ABF3oYppmoKI2kkRB5c66VQRB7e6KqSF0kE3HQTBzbZe8+VIaouiZziHAw/vhWiP2G5PKEYGxLwAgwBrkHDTLGeKEcJoyZgbC+IskbjXEC/WeHlAon9Kq3CXYF75zn4L1FZuUSCzquzMEJAfl9ywRnitPl5HWmBge0WIHJvlzEkH6tzA8i4g4bdiYHvnCjykv376H8yeQVBoW3srQoybvrPwG6xPpIcSRvzmPZQkxfaSaHTf6b63GsEj4/N5k9WdpqRyo9qUgkhY6qq4aWrbqwpwC2ASwBUg0wTrIjBIbBm+k48KUlvZZSH3AByYvrMkqe1eqOYAKngk3LAThYHlXQq5QcGaEjXHyurT30LR/wXrM398mwJLzwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gril.png
// module id = HtZz
// module chunks = 0